import type { Blog, Reference } from '@/types/database'

// Payload documents (depth >= 1) -> the shapes the site already renders.
type MediaLike = { url?: string | null } | number | string | null | undefined

const mediaUrl = (m: MediaLike) => (m && typeof m === 'object' ? m.url ?? undefined : undefined)

export function toBlog(doc: any): Blog {
  return {
    id: String(doc.id),
    title: doc.title,
    excerpt: doc.excerpt,
    content: doc.contentHtml ?? '',
    image: mediaUrl(doc.image),
    status: doc.status,
    published_at: doc.publishedAt ?? undefined,
    created_at: doc.createdAt,
    updated_at: doc.updatedAt,
    slug: doc.slug,
    locale: doc.locale,
  }
}

export function toReference(doc: any): Reference {
  return {
    id: String(doc.id),
    title: doc.title,
    description: doc.descriptionHtml ?? '',
    image: mediaUrl(doc.image) ?? '',
    status: doc.status,
    created_at: doc.createdAt,
    updated_at: doc.updatedAt,
    slug: doc.slug,
    category: doc.category ?? [],
    tags: doc.tags ?? [],
    additional_images: (doc.additionalImages ?? []).map(mediaUrl).filter(Boolean) as string[],
    project_url: doc.projectUrl ?? undefined,
    client_name: doc.clientName ?? undefined,
    technologies: doc.technologies ?? [],
    featured: Boolean(doc.featured),
    completion_date: doc.completionDate ?? undefined,
    locale: doc.locale,
  }
}

// Featured first, then newest — same order the site used before the CMS
export function sortReferences(refs: Reference[]) {
  return refs.sort((a, b) => {
    if (a.featured && !b.featured) return -1
    if (!a.featured && b.featured) return 1
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  })
}
